export enum ConstantConfig {
	TAG = 'app-privateoffshorebackoffice',
	SEGMENT_CLASS = 'ids-theme-',
}
